import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import Keycloak, { KeycloakInstance } from 'keycloak-js';

@Injectable({
  providedIn: 'root',
})
export class KeycloakService {
  private keycloakAuth!: KeycloakInstance;

  public init(): Promise<boolean> {
    const config = {
      url: environment.sso.url,
      realm: environment.sso.realm,
      clientId: environment.sso.resource,
    };

    const initOptions = {
      responseMode: 'fragment' as const,
      flow: 'standard' as const,
      onLoad: 'check-sso'as const,
      checkLoginIframe: false,
    };

    this.keycloakAuth = new Keycloak(config);

    return this.keycloakAuth.init(initOptions);
  }

  getToken(): string {
    return this.keycloakAuth?.token ?? '';
  }

  refreshToken(): Promise<boolean> {
    return this.keycloakAuth.updateToken(30);
  }

  loadUserInfo(): Promise<any> {
    return this.keycloakAuth.loadUserProfile();
  }

  loadUser(): Promise<any> {
    return this.keycloakAuth.loadUserInfo();
  }

  logout(): void {
    this.keycloakAuth.logout({
      redirectUri: `${window.location.origin}/login`,
    });
  }

  login(options?: any): Promise<void> {
    return this.keycloakAuth.login(options);
  }

createLoginUrl(options?: any): Promise<string> {
  console.log('Generando URL de login con opciones:', options);
  return this.keycloakAuth.createLoginUrl(options);
}

  isLoggedIn(): boolean {
    return !!this.keycloakAuth?.authenticated;
  }

  isTokenExpired(): boolean {
    return this.keycloakAuth.isTokenExpired();
  }
}